<div class="flx-row flx-jsb">
  <ng-container *ngIf="!isUploading">
    <input class="d-none" type='file' #fileInput (change)="uploadDoc($event)" />
    <div class="doc-icon pointer" (click)="fileInput.click()"><i class='bx bx-image-add'></i></div>
  </ng-container>
  <ng-container *ngIf="isUploading">
    <div class="loader">
      <div class="loader__ball"></div>
      <div class="loader__ball"></div>
      <div class="loader__ball"></div>
    </div>
  </ng-container>
</div>